"use client";

import { ProductSlider, ProductSliderSkeleton } from "@repo/components";
import { useRecentlyViewedProducts } from "@repo/lib/hooks/product";
import { useTranslations } from "next-intl";
const RecentlyViewed = ({
  productSku,
  session,
  locale,
  wishlistItems
}) => {
  const t = useTranslations("Common");
  const {
    products,
    isPending
  } = useRecentlyViewedProducts(productSku, locale);
  if (!products?.length) return null;
  return isPending ? <div className="mx-auto mb-10 px-4 md:max-w-screen-xl md:px-0" data-sentry-component="RecentlyViewed" data-sentry-source-file="RecentlyViewed.jsx">
      <ProductSliderSkeleton data-sentry-element="ProductSliderSkeleton" data-sentry-source-file="RecentlyViewed.jsx" />
    </div> : <section className="mx-auto mb-10" data-sentry-component="RecentlyViewed" data-sentry-source-file="RecentlyViewed.jsx">
      <ProductSlider title={t("Recently_Viewed")} items={products} isMedium wishlistItems={wishlistItems} session={session} data-sentry-element="ProductSlider" data-sentry-source-file="RecentlyViewed.jsx" />
    </section>;
};
export default RecentlyViewed;